export default __webpack_public_path__ + "static/service-left-main-pic-ac969d4475c0c5d184cf467d3321d7a2.png";